import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import styles from './../Home.module.css';

import { Footer } from '../../components/Footer';
import { LoginModal } from '../LoginModal';
import { Navbar, Toolbar } from '../Home';

import helpStyles from './Help.module.css';
import icon from './help-circle.svg';

import dl1 from './images/dl-1.png';
import dl2 from './images/dl-2.png';
import dl3 from './images/dl-3.png';

import login1 from './images/login-1.png';
import login2 from './images/login-2.png';
import searchImg from './images/search.png';
import cr1 from './images/cr-1.png';
import cr2 from './images/cr-2.png';
import pdfImg from './images/pdf.png';

export function HelpButton() {
	return (
		<Link className={helpStyles['help-button']} to="/help" title="FAQ">
			<img src={icon} />
		</Link>
	);
}
export function Help() {
	const [isLoginOpen, setIsLoginOpen] = useState(false);

	return (
		<>
			<LoginModal
				isOpen={isLoginOpen}
				onClose={() => {
					setIsLoginOpen(false);
				}}
			/>
			<div className={[styles['cha']].join(' ')}>
				<Navbar setIsLoginOpen={setIsLoginOpen} />
				<main className={styles['collections']}>
					<Toolbar />
					<Content />
					<Footer />
				</main>
			</div>
		</>
	);
}

function Content() {
	return (
		<div className={helpStyles['content']}>
			<div>
				<h1>How to use this App</h1>
				<hr />
				<DownloadApp />
				<Logging />
				<Searching />
				<HowToCrossReference />
				<Offline />
				<Pdf />
			</div>
		</div>
	);
}

function Logging() {
	return (
		<section className={helpStyles['login-section']}>
			<h2>Logging into the App </h2>
			<p>To access policy documents, you must be authenticated.</p>
			<p>
				To login, click the login button at the top right of the app (or
				click any policy) and enter a valid email address when promoted.
				If the email entered is validated, you will be logged in and
				access provided.
			</p>
			<div className={helpStyles['login-images']}>
				<img src={login1} />
				<img src={login2} />
			</div>
		</section>
	);
}

function Searching() {
	return (
		<section className={helpStyles['search-section']}>
			<h2>Searching the App</h2>
			<p>
				To search for a keyword, enter the policy you wish to search and
				click the search icon.
			</p>
			<p>
				Enter your search term, the results will be displayed in the
				drop-down menu, or if on mobile, the full screen.
			</p>
			<p>
				Clicking a search result will navigate you to the article and
				highlight all instances of the search term found. If the result
				is not what you are looking for, clicking the search icon again
				will return the search results and allow you select another
				result.
			</p>
			<div>
				<img src={searchImg} />
			</div>
		</section>
	);
}

function HowToCrossReference() {
	return (
		<section className={helpStyles['cross-reference-section']}>
			<h2>How to use the cross-reference navigation </h2>
			<p>
				This app provides a sophisticated cross-reference linking system
				enabling you to not only move quickly to a specific section of a
				policy, but also allow you to navigate back.
			</p>

			<p>
				To navigate to a cross-referenced article, click the hyperlinked
				text within an article.{' '}
			</p>

			<p>
				If the link navigates to another article, a back arrow will
				appear in the bottom right of the article.{' '}
			</p>

			<p>
				Clicking this back button will navigate to the location of the
				previously clicked link. If multiple cross-reference links are
				clicked, the app will remember these steps and allow you to
				navigate back up the ‘breadcrumb’ created.{' '}
			</p>

			<p>
				<strong>Note</strong>: Navigating to another article by swiping
				left right, or back to the home screen will cause any generated
				breadcrumb to be cleaned and ready to be used again.{' '}
			</p>
			<div>
				<img src={cr1} />
				<img src={cr2} />
			</div>
		</section>
	);
}

function Offline() {
	return (
		<section>
			<h2>How to access when offline </h2>

			<p>
				To access the content of a policy when not connected to the
				internet, you first need to download the policy.{' '}
			</p>

			<p>
				To download a policy, first open the policy (when connected to
				the internet) and the app will begin to automatically download
				the content to your device. This is a background process and
				typically takes 30-60 seconds.{' '}
			</p>

			<p>
				Once the download has completed, you will be able to access the
				policy document when you are not connected to the internet.{' '}
			</p>

			<p>
				<strong>Note</strong>: You must be authenticated in the app to
				access content, even when offline.
			</p>
		</section>
	);
}

function Pdf() {
	return (
		<section>
			<h2>How to download a PDF of a policy.</h2>
			<p>
				It is possible to download a PDF of any policy document. To do
				this:
			</p>
			<ol>
				<li>Open the policy document you require</li>
				<li>
					In the top right of the App, click the box with an arrow
					icon
				</li>
				<li>This will open the PDF of the policy in a new tab</li>
				<li>This can then be downloaded to your device</li>
			</ol>
			<div>
				<img src={pdfImg} />
			</div>
		</section>
	);
}

function DownloadApp() {
	return (
		<section>
			<h2>Downloading the app</h2>
			<p>
				The app can either be run directly from your browser, or
				downloaded to your device providing instant access to all policy
				documents on the go.
			</p>
			<h3>Installing a App on iOS</h3>
			<ol>
				<li>
					Navigate to{' '}
					<a href="https://publications.calhospital.org">
						https://publications.calhospital.org
					</a>{' '}
					in Safari{' '}
				</li>
				<li>
					Press the &ldquo;Share&ldquo; button and select &ldquo;Add
					to Home Screen&ldquo; from the popup{' '}
				</li>
				<li>
					Lastly, tap &ldquo;Add&ldquo; in the top right corner to
					finish installing the app
				</li>
				<li>
					The App is now installed and available on your home screen
				</li>
			</ol>
			<h3>Installing a App on Android</h3>
			<ol>
				<li>
					Navigate to{' '}
					<a href="https://publications.calhospital.org">
						https://publications.calhospital.org
					</a>{' '}
					in Chrome{' '}
				</li>
				<li>
					Press the &ldquo;three dot&ldquo; icon in the upper right to
					open the menu{' '}
				</li>
				<li>Select &ldquo;Add to Home screen&ldquo;</li>
				<li>Press the &ldquo;Add&ldquo; button in the popup </li>
				<li>
					The App is now installed and available on your home screen
				</li>
			</ol>
			<div>
				<img src={dl1} />
				<img src={dl2} />
				<img src={dl3} />
			</div>
		</section>
	);
}
